__turbopack_context__.v({
  "numberInput": "NumberInput-module-scss-module__3ZalcG__numberInput",
  "stepper": "NumberInput-module-scss-module__3ZalcG__stepper",
});
